import React, { useEffect, useState } from 'react';
import CustomTh from '../../../../../../components/table/CustomTh';
import CustomTd from '../../../../../../components/table/CustomTd';
import TableFunction from '../../../../../../components/table/TableFunction';
import dayId from '../../../../../../hooks/dayId';
import { VIEW_TYPE } from '../../../../../../enums/ViewType';
import { GetWorkTimeAccess } from '../../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';
import { useDispatch } from 'react-redux';
import {EMPTY_VALUES, errorMsg} from '../../../../../../Apis/functions';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsTableApp = (
    {
        workShift
    }
) => {

    const dispatch = useDispatch();

    const [tableId, setTableId] = useState("tbl_wsta_table");
    const [searchId, setSearchId] = useState("tbl_wsta_search_id");
    const [data, setData] = useState(null);

    const getThead = () => {
        let header = [
            <CustomTh tableId={tableId} classes="first_head">{t('zones')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('day')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('from')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('to')}</CustomTh>
        ];
        return header;
    }

    const getTbody = () => {
        if (!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let body = data?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column"} >{item?.zoneName || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.dayId ? dayId(item?.dayId) : EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.from || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.to || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };

    const { t, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = TableFunction({
        data,
        getThead,
        getTbody,
        labelRowsPerPage: 'accesses_per_page',
        fixedPagination: false,
        view: VIEW_TYPE.LIST.name
    });


    useEffect(() => {
        if (workShift?.id) {
            const body = {
                contractPagination: {
                    order: true,
                    page: page,
                    size: rowsPerPage,
                    sortBy: 'id',
                },
                id: workShift.id
            };
            getData(body);
        }
    }, [workShift]);

    const getData = (body) => {
        dispatch(GetWorkTimeAccess(body)).then(({ payload: { data: { data, success, code } } }) => {
            if (success) setData(data);
            else errorMsg(code)
        })
    }

    return {
        tableId,
        searchId,
        thead,
        tbody,
        pagination, page, setPage, rowsPerPage, setRowsPerPage
    };

}
export default WorkShiftsTableApp;
